import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { faqs } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  const { language, t } = useLanguage();

  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-teal-600 font-medium text-sm uppercase tracking-wider">
            FAQ
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mt-3 mb-4">
            {t.faq.title}
          </h2>
          <p className="text-stone-600 max-w-2xl mx-auto text-lg">
            {t.faq.subtitle}
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className="bg-white rounded-xl border border-stone-200 px-6 overflow-hidden"
            >
              <AccordionTrigger className="text-left font-medium text-stone-800 hover:text-teal-600 hover:no-underline py-5">
                {faq[language].question}
              </AccordionTrigger>
              <AccordionContent className="text-stone-600 pb-5">
                {faq[language].answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;